var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var Result;
(function (Result) {
    Result[Result["Win"] = 0] = "Win";
    Result[Result["Draw"] = 1] = "Draw";
    Result[Result["Loss"] = 2] = "Loss";
})(Result || (Result = {}));
export var getPlayerResult = function (playerId, intraSquadMatch) {
    var result = intraSquadMatch.intraSquadMatchResult;
    if (!result)
        return undefined;
    var isDraw = result.teamAScore === result.teamBScore;
    if (isDraw)
        return Result.Draw;
    var winningTeamPlayers = result.teamAScore > result.teamBScore
        ? intraSquadMatch.teamAPlayers
        : intraSquadMatch.teamBPlayers;
    return (winningTeamPlayers === null || winningTeamPlayers === void 0 ? void 0 : winningTeamPlayers.includes(playerId)) ? Result.Win : Result.Loss;
};
export var aggregatePlayerIntraSquadMatchStats = function (intraSquadMatches) {
    return intraSquadMatches.reduce(function (statsMap, match) {
        var players = __spreadArray(__spreadArray([], __read((match.teamAPlayers || [])), false), __read((match.teamBPlayers || [])), false);
        players.forEach(function (playerId) {
            var _a;
            if (playerId === undefined)
                return;
            // Calculate match-specific stats
            var resultStats = calculatePlayerResultStats(playerId, match);
            var playerStats = (_a = match.playerIntraSquadMatchStats) === null || _a === void 0 ? void 0 : _a.find(function (stat) { return stat.playerId === playerId; });
            // Create new stats or update existing ones
            var existingStats = statsMap[playerId] || {
                matchesPlayed: 0,
                goalsScored: 0,
                yellowCards: 0,
                redCards: 0,
                wins: 0,
                losses: 0,
                draws: 0,
            };
            statsMap[playerId] = {
                matchesPlayed: existingStats.matchesPlayed + 1,
                goalsScored: existingStats.goalsScored + ((playerStats === null || playerStats === void 0 ? void 0 : playerStats.goalsScored) || 0),
                yellowCards: existingStats.yellowCards + ((playerStats === null || playerStats === void 0 ? void 0 : playerStats.yellowCards) || 0),
                redCards: existingStats.redCards + ((playerStats === null || playerStats === void 0 ? void 0 : playerStats.redCards) || 0),
                wins: existingStats.wins + resultStats.wins,
                losses: existingStats.losses + resultStats.losses,
                draws: existingStats.draws + resultStats.draws,
            };
        });
        return statsMap;
    }, {});
};
var calculatePlayerResultStats = function (playerId, intraSquadMatch) {
    var result = getPlayerResult(playerId, intraSquadMatch);
    return {
        wins: result === Result.Win ? 1 : 0,
        draws: result === Result.Draw ? 1 : 0,
        losses: result === Result.Loss ? 1 : 0,
    };
};
export var findPlayerIntraSquadMatchStatByPlayerId = function (stats) {
    return function (id) {
        return stats.find(function (stat) { return stat.playerId === id; });
    };
};
export var findPlayerExternalMatchStatByPlayerId = function (stats) {
    return function (id) {
        return stats.find(function (stat) { return stat.playerId === id; });
    };
};
export var findPlayerIntraSquadTournamentMatchStatByPlayerId = function (stats) {
    return function (id) {
        return stats.find(function (stat) { return stat.playerId === id; });
    };
};
export var findPlayerLeagueMatchStatByPlayerAndTeam = function (stats) {
    return function (playerId, teamId) {
        return stats.find(function (stat) { return stat.playerId === playerId && stat.teamId === teamId; });
    };
};
export var aggregatePlayerStats = function (stats, aggregateFilter) {
    var years = aggregateFilter.years, types = aggregateFilter.types;
    return reducePlayerStats(stats, function (item) { return item.stats; }, function (s) {
        return (!years.length || years.includes(s.year)) &&
            (!types.length || types.includes(s.type));
    }, function (acc, s) {
        acc.matchesPlayed += s.matchesPlayed;
        acc.goalsScored += s.goalsScored;
        acc.redCards += s.redCards;
        acc.yellowCards += s.yellowCards;
    }, function (player) { return ({
        player: player,
        matchesPlayed: 0,
        goalsScored: 0,
        redCards: 0,
        yellowCards: 0,
    }); });
};
export var aggregatePlayerRecords = function (records, aggregateFilter) {
    var e_1, _a;
    var years = aggregateFilter.years, types = aggregateFilter.types;
    var playerRecords = reducePlayerStats(records, function (item) { return item.matchRecords; }, function (r) {
        return (!years.length || years.includes(r.year)) &&
            (!types.length || types.includes(r.type));
    }, function (acc, r) {
        acc.wins += r.wins;
        acc.draws += r.draws;
        acc.losses += r.losses;
    }, function (player) { return ({
        player: player,
        wins: 0,
        draws: 0,
        losses: 0,
        winPercentage: null,
    }); });
    try {
        for (var playerRecords_1 = __values(playerRecords), playerRecords_1_1 = playerRecords_1.next(); !playerRecords_1_1.done; playerRecords_1_1 = playerRecords_1.next()) {
            var record = playerRecords_1_1.value;
            var total = record.wins + record.draws + record.losses;
            record.winPercentage = total > 0 ? record.wins / total : null;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (playerRecords_1_1 && !playerRecords_1_1.done && (_a = playerRecords_1.return)) _a.call(playerRecords_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return playerRecords;
};
export var aggregatePlayerHonors = function (records, aggregateFilter) {
    var years = aggregateFilter.years;
    return reducePlayerStats(records, function (item) { return item.tournamentRecords; }, function (r) { return !years.length || years.includes(r.year); }, function (acc, r) {
        acc.first += r.first;
        acc.second += r.second;
        acc.third += r.third;
        acc.participated += r.participated;
    }, function (player) { return ({
        player: player,
        first: 0,
        second: 0,
        third: 0,
        participated: 0,
    }); });
};
function reducePlayerStats(input, getSubItems, shouldInclude, reducer, createInitial) {
    var e_2, _a, e_3, _b;
    if (!input)
        return [];
    var totals = new Map();
    try {
        for (var input_1 = __values(input), input_1_1 = input_1.next(); !input_1_1.done; input_1_1 = input_1.next()) {
            var item = input_1_1.value;
            var id = item.player.id;
            if (id === undefined)
                continue;
            var player = item.player;
            try {
                for (var _c = (e_3 = void 0, __values(getSubItems(item))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var sub = _d.value;
                    if (!shouldInclude(sub))
                        continue;
                    if (!totals.has(id)) {
                        totals.set(id, createInitial(player));
                    }
                    reducer(totals.get(id), sub);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (input_1_1 && !input_1_1.done && (_a = input_1.return)) _a.call(input_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return __spreadArray([], __read(totals.values()), false);
}
